import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import get from 'lodash/get'
import set from 'lodash/set'
import moment from '../../lib/moment.js'
import { css } from '@emotion/core'
import { BeatLoader } from 'react-spinners'
import { Button, Container, Row, Col, Modal } from 'reactstrap'
import {
  modalAction,
  authAction,
  leaveEntitlementAction,
  leaveTypeAction,
  employeeAction,
} from './../../actions/'
import {
  modalSelector,
  authSelector,
  leaveEntitlementSelector,
  leaveTypeSelector,
  employeeSelector,
} from './../../selectors'
import {
  checkModifiedBy,
  createLeaveTypeListWithoutDeductEntitlement,
  checkLeaveType,
  searchLeaveEntitlement,
} from '../../function'
import CustomModal from '../../components/modal'
import CustomModalMessage from '../../components/modal-message'
import Searchbar from '../../components/searchbar'
import withLayout from '../../helpers/withLayout'
import LeaveEntitlementForm from '../../components/leave-entitlement'
import LeaveEntitlementTable from '../../components/table-leave-entitlement'

class LeaveEntitlementPage extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (get(nextProps, 'getLeaveEntitlementData')) {
      set(tempState, 'leaveEntitlement', nextProps.getLeaveEntitlementData)
      set(tempState, 'defaultLeaveEntitlement', nextProps.getLeaveEntitlementData)
      nextProps.resetGetLeaveEntitlement()
    }
    if (nextProps.getLeaveEntitlementByIDData) {
      set(tempState, 'start_date', get(nextProps, 'getLeaveEntitlementByIDData.start_date'))
      set(tempState, 'end_date', get(nextProps, 'getLeaveEntitlementByIDData.end_date'))
      set(tempState, 'leave_entitlement_code', get(nextProps, 'getLeaveEntitlementByIDData.leave_entitlement_code'))
      set(tempState, 'name', get(nextProps, 'getLeaveEntitlementByIDData.name'))
      set(tempState, 'leave_type_id', checkLeaveType(get(nextProps, 'getLeaveEntitlementByIDData.leave_type_id'), prevState.leaveTypeList))
      set(tempState, 'leave_total_default', get(nextProps, 'getLeaveEntitlementByIDData.leave_total_default'))
      set(tempState, 'is_prorate', get(nextProps, 'getLeaveEntitlementByIDData.is_prorate'))
      set(tempState, 'is_active', get(nextProps, 'getLeaveEntitlementByIDData.is_active'))
      set(tempState, 'sequence', get(nextProps, 'getLeaveEntitlementByIDData.sequence'))
      set(tempState, 'updated', get(nextProps, 'getLeaveEntitlementByIDData.updated'))
      set(tempState, 'updated_by', checkModifiedBy(get(nextProps, 'getLeaveEntitlementByIDData.updated_by'), prevState.employeeList))
      nextProps.resetGetLeaveEntitlementByID()
    }
    if (get(nextProps, 'createLeaveEntitlementData.createdLeaveEntitlement')) {
      const access_token = localStorage.getItem('access_token')
      const status = get(nextProps, 'createLeaveEntitlementData.status')
      const message = get(nextProps, 'createLeaveEntitlementData.message')
      if (status !== 200) {
        nextProps.showModal('leaveEntitlement', status, message)
      } else {
        nextProps.showConfirm('createSuccess', status, message)
      }
      nextProps.getLeaveEntitlement(access_token)
      nextProps.resetCreateLeaveEntitlement()
    }
    if (get(nextProps, 'editLeaveEntitlementData.updateLeaveEntitlement')) {
      const access_token = localStorage.getItem('access_token')
      const status = get(nextProps, 'editLeaveEntitlementData.status')
      const message = get(nextProps, 'editLeaveEntitlementData.message')
      set(tempState, 'start_date', get(nextProps, 'editLeaveEntitlementData.updateLeaveEntitlement.start_date'))
      set(tempState, 'end_date', get(nextProps, 'editLeaveEntitlementData.updateLeaveEntitlement.end_date'))
      set(tempState, 'leave_entitlement_code', get(nextProps, 'editLeaveEntitlementData.updateLeaveEntitlement.leave_entitlement_code'))
      set(tempState, 'name', get(nextProps, 'editLeaveEntitlementData.updateLeaveEntitlement.name'))
      set(tempState, 'leave_type_id', checkLeaveType(get(nextProps, 'editLeaveEntitlementData.updateLeaveEntitlement.leave_type_id'), prevState.leaveTypeList))
      set(tempState, 'leave_total_default', get(nextProps, 'editLeaveEntitlementData.updateLeaveEntitlement.leave_total_default'))
      set(tempState, 'is_prorate', get(nextProps, 'editLeaveEntitlementData.updateLeaveEntitlement.is_prorate'))
      set(tempState, 'is_active', get(nextProps, 'editLeaveEntitlementData.updateLeaveEntitlement.is_active'))
      set(tempState, 'sequence', get(nextProps, 'editLeaveEntitlementData.updateLeaveEntitlement.sequence'))
      set(tempState, 'updated', get(nextProps, 'editLeaveEntitlementData.updateLeaveEntitlement.updated'))
      set(tempState, 'updated_by', checkModifiedBy(get(nextProps, 'editLeaveEntitlementData.updateLeaveEntitlement.updated_by'), prevState.employeeList))
      set(tempState, 'isEdit', false)
      if (status !== 200) {
        nextProps.showModal('leaveEntitlement', status, message)
      } else {
        nextProps.showConfirm('editSuccess', status, message)
      }
      nextProps.getLeaveEntitlementByID(prevState.leaveEntitlementID, access_token)
      nextProps.getLeaveEntitlement(access_token)
      nextProps.resetEditLeaveEntitlement()
    }
    if (get(nextProps, 'deleteLeaveEntitlementData.deletedLeaveType')) {
      const access_token = localStorage.getItem('access_token')
      nextProps.showConfirm('deleteSuccess', get(nextProps, 'deleteLeaveEntitlementData.status'), get(nextProps, 'deleteLeaveEntitlementData.message'))
      nextProps.getLeaveEntitlement(access_token)
      nextProps.resetDeleteLeaveEntitlement()
    }
    if (nextProps.getEmployeeData !== prevState.employeeList) {
      set(tempState, 'employeeList', nextProps.getEmployeeData)
    }
    if (get(nextProps, 'getLeaveTypeData')) {
      set(tempState, 'leaveTypeList', createLeaveTypeListWithoutDeductEntitlement(nextProps.getLeaveTypeData))
      nextProps.resetGetLeaveType()
    }
    return tempState
  }

  constructor(props) {
    super(props)
    this.state = {
      rowID: '',
      isSpan: false,
      isEdit: false,
      leaveEntitlementID: '',
      defaultLeaveEntitlement: [],
      leaveEntitlement: [],
      start_date: '',
      end_date: '',
      leave_entitlement_code: '',
      name: '',
      leave_type_id: '',
      leave_total_default: 0,
      is_prorate: false,
      updated: '',
      updated_by: '',
      is_active: true,
      sequence: 1,
      employeeList: [],
      leaveTypeList: [],
      search: '',
    }
    this.handleClickRow = this.handleClickRow.bind(this)
    this.handleClickEdit = this.handleClickEdit.bind(this)
    this.handleInput = this.handleInput.bind(this)
    this.handleDiscard = this.handleDiscard.bind(this)
    this.showForm = this.showForm.bind(this)
    this.cancelForm = this.cancelForm.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.showDiscard = this.showDiscard.bind(this)
    this.cancelDiscard = this.cancelDiscard.bind(this)
    this.showDelete = this.showDelete.bind(this)
    this.cancelDelete = this.cancelDelete.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.handleLeaveType = this.handleLeaveType.bind(this)
    this.handleClickSearch = this.handleClickSearch.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
  }

  componentDidMount() {
    const access_token = localStorage.getItem('access_token')
    this.props.getAuth(access_token)
    this.props.getLeaveEntitlement(access_token)
    this.props.getLeaveType(access_token)
    this.props.getEmployee(access_token)
  }

  handleInput(e) {
    if (e.target.type === 'checkbox') {
      this.setState({ [e.target.name]: e.target.checked })
    } else this.setState({ [e.target.name]: e.target.value })
  }

  handleLeaveType(e) {
    this.setState({ leave_type_id: e })
  }

  handleClickEdit() {
    this.setState({ isEdit: !this.state.isEdit })
  }

  handleClickRow(span, id, editID) {
    this.setState({
      isSpan: span,
      leaveEntitlementID: id,
      rowID: editID,
      isEdit: false,
    })
    if (span) {
      const access_token = localStorage.getItem('access_token')
      this.props.getLeaveEntitlementByID(id, access_token)
    }
  }

  handleClickSearch() {
    this.setState({
      leaveEntitlement: get(this.state, 'defaultLeaveEntitlement').filter(searchLeaveEntitlement, this.state.search),
    })
  }

  handleSearch(e) {
    if (e.keyCode === 13) this.handleClickSearch()
    else if (e.target.value === '') this.setState({ leaveEntitlement: get(this.state, 'defaultLeaveEntitlement'), search: '' })
    else this.setState({ search: e.target.value })
  }

  showForm() {
    this.setState({
      start_date: '',
      end_date: '',
      leave_entitlement_code: '',
      name: '',
      leave_type_id: '',
      leave_total_default: '',
      is_prorate: false,
      is_active: true,
      sequence: 1,
      isEdit: false,
      isSpan: false,
      leaveEntitlementID: '',
      rowID: '',
    })
    this.props.showModal('holidayForm')
  }

  cancelForm() {
    this.props.hideModal('holidayForm')
  }

  showDelete() {
    this.props.showConfirm('confirmDelete', 'Delete Comfirmation', 'Are you sure to delete ?')
  }

  cancelDelete() {
    this.props.hideConfirm('confirmDelete')
  }

  handleDelete() {
    const access_token = localStorage.getItem('access_token')
    this.props.deleteLeaveEntitlement(this.state.leaveEntitlementID, access_token)
    this.handleClickRow(false, '', '')
    this.cancelDelete()
  }

  showDiscard() {
    if (this.state.isEdit) {
      this.props.showConfirm('confirmDiscard', 'Discard Changes', 'Are you sure you want to discard all changes ?')
    } else this.handleClickRow(false, '', '')
  }

  cancelDiscard() {
    this.props.hideConfirm('confirmDiscard')
  }

  handleDiscard() {
    this.cancelDiscard()
    this.handleClickRow(false, '', '')
  }

  submitForm() {
    const payload = {
      start_date: this.state.start_date ? moment(this.state.start_date) : '',
      end_date: this.state.end_date ? moment(this.state.end_date) : '',
      leave_entitlement_code: this.state.leave_entitlement_code,
      name: this.state.name,
      leave_type_id: this.state.leave_type_id.leave_type_id,
      leave_total_default: parseInt(this.state.leave_total_default, 10),
      is_prorate: this.state.is_prorate,
      is_active: this.state.is_active,
      sequence: this.state.sequence,
    }
    const access_token = localStorage.getItem('access_token')
    if (this.state.isEdit) {
      delete payload.leave_total_default
      delete payload.leave_type_id
      delete payload.is_prorate
      delete payload.start_date
      delete payload.end_date
      this.props.editLeaveEntitlement(this.state.leaveEntitlementID, payload, access_token)
    } else this.props.createLeaveEntitlement(payload, access_token)
    this.cancelForm()
  }

  render() {
    const IsAdminUser = get(this.props, 'authData.user.is_hr_admin_role')
    const IsSystemUser = get(this.props, 'authData.user.is_system_admin')
    const IsHRConfidentialUser = get(this.props, 'authData.user.is_hr_admin_confidential_role')
    const IsManagementUser = get(this.props, 'authData.user.is_management_role')

    const isAuthenticated = get(this.props, 'redirectAuth.isAuthenticated')
    || get(this.props, 'redirectEntitlement.isAuthenticated')
    const redirect = get(this.props, 'redirectAuth.redirect')
      || get(this.props, 'redirectEntitlement.redirect')
    if (redirect) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      this.props.resetAuth()
      window.location = '/'
    }

    if (IsHRConfidentialUser !== undefined &&
      IsSystemUser !== undefined &&
      IsAdminUser !== undefined &&
      IsManagementUser !== undefined &&
      !(IsHRConfidentialUser || IsSystemUser || IsAdminUser || IsManagementUser)) window.location = '/home'

    const button = (
      <NewButton color="success" onClick={ this.state.isEdit ? this.submitForm : this.handleClickEdit }>{ this.state.isEdit ? 'Save' : 'Edit' }</NewButton>
    )
    const buttonOK = (type) => (
      <NewButton color="success" onClick={ () => this.props.hideConfirm(type) }>OK</NewButton>
    )
    const buttonCreate = (
      <NewButton color="success" onClick={ this.submitForm }>Create</NewButton>
    )
    const buttonDiscard = (
      <div>
        <NewButton color="" onClick={ this.cancelDiscard }>Cancel</NewButton>
        <NewButton color="danger" onClick={ this.handleDiscard }>Discard</NewButton>
      </div>
    )
    const buttonDelete = (
      <div>
        <NewButton color="" onClick={ this.cancelDelete }>Cancel</NewButton>
        <NewButton color="danger" onClick={ this.handleDelete }>Delete</NewButton>
      </div>
    )
    const isFetching = get(this.props, 'getIsFetchingEntitlement')
    || get(this.props, 'getIsFetchingLeaveType')
    || get(this.props, 'getIsFetchingEmployee')

    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper fluid>
        <Searchbar
          toggleCreate={ this.showForm }
          handleSearch={ this.handleSearch }
          handleClickSearch={ this.handleClickSearch }
          search={ this.state.search }
        />
        { isFetching &&
          <Overlay>
            <OverlayWrapper>
              <BeatLoader
                css={ css(`
                  position: absolute;
                  left: 50%;
                  top: 50%;
                `) }
                sizeUnit={ "px" }
                size={ 15 }
                color={ '#D44B49' }
                loading={ isFetching }
              />
            </OverlayWrapper>
          </Overlay>
        }
        <CustomModal
          hide={ () => this.props.hideModal('leaveEntitlement') }
          show={ get(this.props, 'modalType') === 'leaveEntitlement' }
          type={ get(this.props, 'modalStatus') }
          message={ get(this.props, 'modalMessage') }
        />
        <Row noGutters>
          <CustomModalMessage
            hide={ () => this.props.hideConfirm('createSuccess') }
            show={ get(this.props, 'confirmType') === 'createSuccess' }
            type={ get(this.props, 'confirmStatus') }
            message={ get(this.props, 'confirmMessage') }
            button={ buttonOK('createSuccess') }
          />
          <CustomModalMessage
            hide={ () => this.props.hideConfirm('editSuccess') }
            show={ get(this.props, 'confirmType') === 'editSuccess' }
            type={ get(this.props, 'confirmStatus') }
            message={ get(this.props, 'confirmMessage') }
            button={ buttonOK('editSuccess') }
          />
          <CustomModalMessage
            hide={ this.cancelDiscard }
            show={ get(this.props, 'confirmType') === 'confirmDiscard' }
            type={ get(this.props, 'confirmStatus') }
            message={ get(this.props, 'confirmMessage') }
            button={ buttonDiscard }
          />
          <CustomModalMessage
            hide={ this.cancelDelete }
            show={ get(this.props, 'confirmType') === 'confirmDelete' }
            type={ get(this.props, 'confirmStatus') }
            message={ get(this.props, 'confirmMessage') }
            button={ buttonDelete }
          />
          <Row noGutters>
            <Col>
              <LeaveEntitlementTable
                handleInput={ this.handleInput }
                handleClickRow={ this.handleClickRow }
                { ...this.state }
              />
            </Col>
            {
              this.state.isSpan &&
              <Col>
                <LeaveEntitlementForm
                  handleInput={ this.handleInput }
                  button={ button }
                  { ...this.state }
                  handleClickRow={ this.handleClickRow }
                  handleLeaveType={ this.handleLeaveType }
                  cancelForm={ this.cancelForm }
                  showDelete={ this.showDelete }
                  cancelDelete={ this.cancelDelete }
                  showDiscard={ this.showDiscard }
                  cancelDiscard={ this.cancelDiscard }
                />
              </Col>
            }
          </Row>
          <Modal isOpen={ get(this.props, 'modalType') === 'holidayForm' } toggle={ this.cancelForm }>
            <LeaveEntitlementForm
              create={ true }
              button={ buttonCreate }
              { ...this.state }
              handleInput={ this.handleInput }
              handleLeaveType={ this.handleLeaveType }
              cancelForm={ this.cancelForm }
            />
          </Modal>
        </Row>
      </Wrapper>
    )
  }
}

LeaveEntitlementPage.propTypes = {
  getAuth: PropTypes.func.isRequired,
  resetAuth: PropTypes.func.isRequired,
  getLeaveEntitlement: PropTypes.func.isRequired,
  getEmployee: PropTypes.func.isRequired,
  getLeaveEntitlementByID: PropTypes.func.isRequired,
  getLeaveType: PropTypes.func.isRequired,
  editLeaveEntitlement: PropTypes.func.isRequired,
  createLeaveEntitlement: PropTypes.func.isRequired,
  deleteLeaveEntitlement: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  showConfirm: PropTypes.func.isRequired,
  hideConfirm: PropTypes.func.isRequired,
}

const mapStateToProps = (state, props) => createStructuredSelector({
  modalStatus: modalSelector.modalStatus,
  modalType: modalSelector.modalType,
  modalMessage: modalSelector.modalMessage,
  confirmStatus: modalSelector.confirmStatus,
  confirmType: modalSelector.confirmType,
  confirmMessage: modalSelector.confirmMessage,
  authData: authSelector.getAuth,
  redirectAuth: authSelector.redirectAuth,
  redirectEntitlement: leaveEntitlementSelector.redirectEntitlement,
  getIsFetchingEntitlement: leaveEntitlementSelector.getIsFetching,
  getIsFetchingLeaveType: leaveTypeSelector.getIsFetching,
  getIsFetchingEmployee: employeeSelector.getIsFetching,
  getLeaveEntitlementData: leaveEntitlementSelector.getLeaveEntitlementData,
  getLeaveEntitlementByIDData: leaveEntitlementSelector.getLeaveEntitlementByIDData,
  editLeaveEntitlementData: leaveEntitlementSelector.editLeaveEntitlementData,
  createLeaveEntitlementData: leaveEntitlementSelector.createLeaveEntitlementData,
  deleteLeaveEntitlementData: leaveEntitlementSelector.deleteLeaveEntitlementData,
  getLeaveTypeData: leaveTypeSelector.getLeaveTypeData,
  getEmployeeData: employeeSelector.getListUser,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  showModal: modalAction.showModal,
  hideModal: modalAction.hideModal,
  showConfirm: modalAction.showConfirm,
  hideConfirm: modalAction.hideConfirm,
  getAuth: authAction.auth,
  resetAuth: authAction.resetAuthUser,
  getLeaveEntitlement: leaveEntitlementAction.getLeaveEntitlement,
  resetGetLeaveEntitlement: leaveEntitlementAction.resetGetLeaveEntitlement,
  getLeaveEntitlementByID: leaveEntitlementAction.getLeaveEntitlementByID,
  resetGetLeaveEntitlementByID: leaveEntitlementAction.resetGetLeaveEntitlementByID,
  editLeaveEntitlement: leaveEntitlementAction.editLeaveEntitlement,
  resetEditLeaveEntitlement: leaveEntitlementAction.resetEditLeaveEntitlement,
  createLeaveEntitlement: leaveEntitlementAction.createLeaveEntitlement,
  resetCreateLeaveEntitlement: leaveEntitlementAction.resetCreateLeaveEntitlement,
  deleteLeaveEntitlement: leaveEntitlementAction.deleteLeaveEntitlement,
  resetDeleteLeaveEntitlement: leaveEntitlementAction.resetDeleteLeaveEntitlement,
  getLeaveType: leaveTypeAction.getLeaveType,
  resetGetLeaveType: leaveTypeAction.resetGetLeaveType,
  getEmployee: employeeAction.getUser,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withLayout(LeaveEntitlementPage))

const Wrapper = styled(Container)`
  padding: 0px;
`
const NewButton = styled(Button)`
  width: 100px;
`
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`
const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`



// WEBPACK FOOTER //
// ./src/pages/leave-entltlement/index.js